import {Component, OnInit, TemplateRef} from '@angular/core';
import {IAfterGuiAttachedParams, ICellRendererParams} from 'ag-grid-community';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'lib-colli-info-cell',
  templateUrl: './colli-info-cell.component.html',
  styleUrls: ['./colli-info-cell.component.css']
})
export class ColliInfoCellComponent implements OnInit, ICellRendererAngularComp {
  modalRef: BsModalRef;
  faInfoCircle = faInfoCircle;
  public params: ICellRendererParams;


  constructor(private modalService: BsModalService) {}

  ngOnInit(): void {
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  displayInfos(template: TemplateRef<any>): void {
    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
    };
    this.modalRef = this.modalService.show(template, config);
  }

  showDimensions(values: any) {
    const laenge = values.laenge !== null ? values.laenge : '0';
    const breite = values.breite !== null ? values.breite : '0';
    const hoehe = values.hoehe !== null ? values.hoehe : '0';
    const volumen = values.volumen !== null ? values.volumen : '0';

    return laenge + ' ' + ' x ' + breite + ' ' + ' x ' + hoehe + ' ' + ' / ' + volumen;
  }

  checkValues(values: any) {
    if (values === '' || values === undefined || values === null) {
      return '-';
    } else {
      return values;
    }
  }
}
